import styled from 'styled-components'

export const StyledError = styled.span`
  font-size: var(--fs-sm);
  color: var(--color-red-2);
  font-weight: bold;
`
